import { handleResponse } from 'helper/handleResponse';
import { authHeader } from 'helper/authHeader';
import { baseUrl } from 'helper/ApiCall';

export const companyService = {
    getCompany,
    storeCompany,
    editCompany,
    deleteCompany,
    getCompaniesPagination,

    // storeCompanyUser,
    // getCompanyUser,
    // editCompanyUser,
    // getCompanyUsers,
    // deleteCompanyUser,
    
    getCompanyProfileInfo,
    getCompanyAllUsersPagination
}


function getCompanyProfileInfo(id){


    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(baseUrl+'company/show/'+id, requestOptions).then(handleResponse);
}

function getCompany(id){

	const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };



    return fetch(baseUrl+'company/'+id, requestOptions).then(handleResponse);
}

function storeCompany(companyData){

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(companyData)
    };

    return fetch(baseUrl+'company', requestOptions)
        .then(handleResponse)
        .then(company => {
            return company;
        });
}


function editCompany(id, companyData){
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(companyData)
    };

    return fetch(baseUrl+'company/'+id, requestOptions)
            .then(handleResponse)
            .then(company => {
                return company;
            })
}


function deleteCompany(id){
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };


    return fetch(baseUrl+'company/'+id, requestOptions).then(handleResponse);
}

function getCompaniesPagination(page, filter, sort, pageSize){
    const requestOptions = {
        method  : 'GET',
        headers : authHeader()
    };
    return fetch(baseUrl+'companyPagination?page='+page+'&filter='+filter+'&sort='+sort+'&pageSize='+pageSize, requestOptions).then(handleResponse);
}

// function storeCompanyUser(companyUserData, companyId){
//     const requestOptions = {
//         method: 'POST',
//         headers: authHeader(),
//         body: JSON.stringify(companyUserData)
//     };


//     return fetch(baseUrl+'company/'+companyId+'/user', requestOptions)
//             .then(handleResponse)
//             .then(company => {
//                 return company;
//             })
// }

// function getCompanyUser(userId){

//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader()
//     };



//     return fetch(baseUrl+'company/'+userId+'/user', requestOptions).then(handleResponse);
// }

// function editCompanyUser(companyUserData, companyId, userId){
//     const requestOptions = {
//         method: 'PUT',
//         headers: authHeader(),
//         body: JSON.stringify(companyUserData)
//     };

//     return fetch(baseUrl+'company/'+companyId+'/user/'+userId, requestOptions)
//     .then(handleResponse)
//     .then(company => {
//         return company;
//     })
// }


// function deleteCompanyUser(companyId, userId){
//     const requestOptions = {
//         method: 'DELETE',
//         headers: authHeader()

//     };


//     return fetch(baseUrl+'company/'+companyId+'/user/'+userId, requestOptions).then(handleResponse);
// }


// function getCompanyUsers(companyId){


//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader()
//     };



//     return fetch(baseUrl+'company/'+companyId+'/users', requestOptions).then(handleResponse);
// }


// function getFestivalsPagination(page, filter, sort, companyId){
//     const requestOptions = {
//         method  : 'GET',
//         headers : authHeader()
//     };
//     if (companyId == null)
//         return fetch(baseUrl+'festivalsPagination?page='+page+'&filter='+filter+'&sort='+sort, requestOptions).then(handleResponse);
//     else
//         return fetch(baseUrl+'festivalsPagination/'+companyId+'?page='+page+'&filter='+filter+'&sort='+sort, requestOptions).then(handleResponse);
// }

function getCompanyAllUsersPagination(page, filter, sort, pageSize){
    const requestOptions = {
        method  : 'GET',
        headers : authHeader()
    };
    return fetch(baseUrl+'getAllCompanyUsers?page='+page+'&filter='+filter+'&sort='+sort+'&pageSize='+pageSize, requestOptions).then(handleResponse);
}



// WEBPACK FOOTER //
// ./src/services/company.js